/* tslint:disable */
/* eslint-disable */
/**
 * Price and Capacity Track & automatic reserve Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const BaggageTypes = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type BaggageTypes = typeof BaggageTypes[keyof typeof BaggageTypes];



